export const categories = [
  { name: "New", icon: "ic:round-home" },
  { name: "Coding", icon: "mdi:code" },
  { name: "ReactJS", icon: "bxl:react" },
  { name: "NextJS", icon: "tabler:brand-nextjs" },
  { name: "VueJs", icon: "cib:vue-js" },
  { name: "Music", icon: "ri:music-fill" },
  { name: "Education", icon: "fluent-mdl2:education" },
  { name: "Podcast", icon: "ic:twotone-graphic-eq" },
  { name: "Movie", icon: "icon-park-outline:movie" },
  { name: "Gaming", icon: "mdi:youtube-gaming" },
  { name: "Live", icon: "ic:baseline-live-tv" },
  { name: "Sport", icon: "fluent:sport-soccer-20-filled" },
  { name: "Fashion", icon: "ic:twotone-checkroom" },
  { name: "Beauty", icon: "ic:baseline-face-retouching-natural" },
  { name: "Comedy", icon: "ic:round-theater-comedy" },
  { name: "Gym", icon: "gg:gym" },
  { name: "Crypto", icon: "akar-icons:bitcoin-fill" },
];

export const videos: Video[] | Channel[] = [
  {
    kind: "youtube#searchResult",
    id: {
      kind: "youtube#video",
      videoId: "Ry5jMDhgDDc",
    },
    snippet: {
      publishedAt: "2023-12-22T15:00:21Z",
      channelId: "UCEjFo_MuGVLeWi_cL7OpBhg",
      title: "Juice WRLD, Eminem &amp; benny blanco - Lace It (Lyrics)",
      description:
        "Juice WRLD, Eminem & Benny Blanco - Lace It (Lyrics) Witness the powerhouse collaboration of Juice WRLD, Eminem, and ...",
      thumbnails: {
        default: {
          url: "https://i.ytimg.com/vi/Ry5jMDhgDDc/default.jpg",
          width: 120,
          height: 90,
        },
        medium: {
          url: "https://i.ytimg.com/vi/Ry5jMDhgDDc/mqdefault.jpg",
          width: 320,
          height: 180,
        },
        high: {
          url: "https://i.ytimg.com/vi/Ry5jMDhgDDc/hqdefault.jpg",
          width: 480,
          height: 360,
        },
      },
      channelTitle: "REDMADMUSIC",
      liveBroadcastContent: "none",
      publishTime: "2023-12-22T15:00:21Z",
    },
  },
  {
    kind: "youtube#searchResult",
    id: {
      kind: "youtube#video",
      videoId: "Ry5jMDhgDDc",
    },
    snippet: {
      publishedAt: "2023-12-22T15:00:21Z",
      channelId: "UCEjFo_MuGVLeWi_cL7OpBhg",
      title: "Juice WRLD, Eminem &amp; benny blanco - Lace It (Lyrics)",
      description:
        "Juice WRLD, Eminem & Benny Blanco - Lace It (Lyrics) Witness the powerhouse collaboration of Juice WRLD, Eminem, and ...",
      thumbnails: {
        default: {
          url: "https://i.ytimg.com/vi/Ry5jMDhgDDc/default.jpg",
          width: 120,
          height: 90,
        },
        medium: {
          url: "https://i.ytimg.com/vi/Ry5jMDhgDDc/mqdefault.jpg",
          width: 320,
          height: 180,
        },
        high: {
          url: "https://i.ytimg.com/vi/Ry5jMDhgDDc/hqdefault.jpg",
          width: 480,
          height: 360,
        },
      },
      channelTitle: "REDMADMUSIC",
      liveBroadcastContent: "none",
      publishTime: "2023-12-22T15:00:21Z",
    },
  },
  {
    kind: "youtube#searchResult",
    id: {
      kind: "youtube#video",
      videoId: "Ry5jMDhgDDc",
    },
    snippet: {
      publishedAt: "2023-12-22T15:00:21Z",
      channelId: "UCEjFo_MuGVLeWi_cL7OpBhg",
      title: "Juice WRLD, Eminem &amp; benny blanco - Lace It (Lyrics)",
      description:
        "Juice WRLD, Eminem & Benny Blanco - Lace It (Lyrics) Witness the powerhouse collaboration of Juice WRLD, Eminem, and ...",
      thumbnails: {
        default: {
          url: "https://i.ytimg.com/vi/Ry5jMDhgDDc/default.jpg",
          width: 120,
          height: 90,
        },
        medium: {
          url: "https://i.ytimg.com/vi/Ry5jMDhgDDc/mqdefault.jpg",
          width: 320,
          height: 180,
        },
        high: {
          url: "https://i.ytimg.com/vi/Ry5jMDhgDDc/hqdefault.jpg",
          width: 480,
          height: 360,
        },
      },
      channelTitle: "REDMADMUSIC",
      liveBroadcastContent: "none",
      publishTime: "2023-12-22T15:00:21Z",
    },
  },
  {
    kind: "youtube#searchResult",
    id: {
      kind: "youtube#video",
      videoId: "Ry5jMDhgDDc",
    },
    snippet: {
      publishedAt: "2023-12-22T15:00:21Z",
      channelId: "UCEjFo_MuGVLeWi_cL7OpBhg",
      title: "Juice WRLD, Eminem &amp; benny blanco - Lace It (Lyrics)",
      description:
        "Juice WRLD, Eminem & Benny Blanco - Lace It (Lyrics) Witness the powerhouse collaboration of Juice WRLD, Eminem, and ...",
      thumbnails: {
        default: {
          url: "https://i.ytimg.com/vi/Ry5jMDhgDDc/default.jpg",
          width: 120,
          height: 90,
        },
        medium: {
          url: "https://i.ytimg.com/vi/Ry5jMDhgDDc/mqdefault.jpg",
          width: 320,
          height: 180,
        },
        high: {
          url: "https://i.ytimg.com/vi/Ry5jMDhgDDc/hqdefault.jpg",
          width: 480,
          height: 360,
        },
      },
      channelTitle: "REDMADMUSIC",
      liveBroadcastContent: "none",
      publishTime: "2023-12-22T15:00:21Z",
    },
  },
  {
    kind: "youtube#searchResult",
    id: {
      kind: "youtube#video",
      videoId: "Ry5jMDhgDDc",
    },
    snippet: {
      publishedAt: "2023-12-22T15:00:21Z",
      channelId: "UCEjFo_MuGVLeWi_cL7OpBhg",
      title: "Juice WRLD, Eminem &amp; benny blanco - Lace It (Lyrics)",
      description:
        "Juice WRLD, Eminem & Benny Blanco - Lace It (Lyrics) Witness the powerhouse collaboration of Juice WRLD, Eminem, and ...",
      thumbnails: {
        default: {
          url: "https://i.ytimg.com/vi/Ry5jMDhgDDc/default.jpg",
          width: 120,
          height: 90,
        },
        medium: {
          url: "https://i.ytimg.com/vi/Ry5jMDhgDDc/mqdefault.jpg",
          width: 320,
          height: 180,
        },
        high: {
          url: "https://i.ytimg.com/vi/Ry5jMDhgDDc/hqdefault.jpg",
          width: 480,
          height: 360,
        },
      },
      channelTitle: "REDMADMUSIC",
      liveBroadcastContent: "none",
      publishTime: "2023-12-22T15:00:21Z",
    },
  },
];

export const channel: Channel = {
  kind: "youtube#searchResult",
  id: {
    kind: "youtube#channel",
    channelId: "UCBRc-CtQGfFdNoL5YnoF3GQ",
  },
  snippet: {
    publishedAt: "2023-09-21T07:29:22Z",
    channelId: "UCBRc-CtQGfFdNoL5YnoF3GQ",
    title: "Rimi’s Kitchen",
    description:
      "Hii,welcome to our channel. I'm Rimjim Bora.I love to cook and create recipes and I'm so excited to share them with you all.",
    thumbnails: {
      default: {
        url: "https://yt3.ggpht.com/MTVpO5s8vzASxQEG3vbi1V8so9AeiupBdAdZg1UfcKBBkO0l8v0ehsDptPTh_LlfdPOi3YxijQ=s88-c-k-c0xffffffff-no-rj-mo",
        width: 0,
        height: 0,
      },
      medium: {
        url: "https://yt3.ggpht.com/MTVpO5s8vzASxQEG3vbi1V8so9AeiupBdAdZg1UfcKBBkO0l8v0ehsDptPTh_LlfdPOi3YxijQ=s240-c-k-c0xffffffff-no-rj-mo",
        width: 0,
        height: 0,
      },
      high: {
        url: "https://yt3.ggpht.com/MTVpO5s8vzASxQEG3vbi1V8so9AeiupBdAdZg1UfcKBBkO0l8v0ehsDptPTh_LlfdPOi3YxijQ=s800-c-k-c0xffffffff-no-rj-mo",
        width: 0,
        height: 0,
      },
    },

    channelTitle: "Rimi’s Kitchen",
    liveBroadcastContent: "none",
    publishTime: "2023-09-21T07:29:22Z",
  },
};

export const videoDetails: VideoDetails = {
  kind: "youtube#video",
  id: "7ghhRHRP6t4",
  snippet: {
    publishedAt: "2020-07-24T04:00:10Z",
    channelId: "UCN1hnUccO4FD5WfM7ithXaw",
    title: "Maroon 5 - Nobody's Love (Official Music Video)",
    description:
      "“Nobody’s Love” is out now: https://smarturl.it/NobodysLove For more, visit: Instagram: https://www.instagram.com/maroon5 Facebook: https://www.facebook.com/maroon5 Twitter: https://twitter.com/maroon5 Sign up for updates: http://smarturl.it/Maroon5.News // LYRICS You could make a grown man cry If you ever said goodbye Never let you go oh-woah oh-I Never let you go oh-woah oh-I You could make a grown man cry If you ever left my side Never let you go oh-woah oh-I Never let you go oh-woah oh-I You’re the only hand in my back pocket If you ever left I’d go psychotic Heaven hear me cryin cryin oh oh Baby you’re the key to my heart locket If you ever left never unlock it Lonely like an island, island oh oh If my love ain’t your love it’s never gonna be nobody’s love Never gonna need nobody’s love, but yours, but yours If my love ain’t your love it’s never gonna be nobody’s love Never gonna need nobody’s trust but yours, but yours You could make a grown man cry If you ever said goodbye Never let you go oh-woah oh-I Never let you go oh-woah oh-I You could make a grown man cry, if you ever left my side Never let you go never let you go You’re the only hand in my back pocket If you ever left I’d go psychotic Heaven hear me cryin cryin oh oh Hit me like a drug and I can’t stop it Fit me like a glove and I cant knock it. I aint even lying lying oh oh If my love ain’t your love it’s never gonna be nobody’s love Never gonna need nobody’s love but yours, but yours If my love ain’t your love it’s never gonna be nobody’s love Never gonna keep nobody’s trust but yours, but yours If my love ain’t your love then it’s nobody’s Only yours only yours not just anybody And If you ever leave then i’m never gonna want nobody, nobody’s love If my love ain’t your love then it’s nobody’s Only yours only yours not just anybody And If you ever leave then i’m never gonna want nobody, nobody’s love Nobody’s love! Oh yea If my love ain’t your love it’s never gonna be nobody’s love Never gonna need nobody’s love but yours, but yours If my love ain’t your love it’s never gonna be nobody’s love Never gonna need nobody’s love but yours, but yours If my love ain’t your love then it’s nobody’s Only yours only yours not just anybody And If you ever leave then i’m never gonna want nobody, nobody’s love If my love ain’t your love then it’s nobody’s Only yours only yours not just anybody And If you ever leave then i’m never gonna want nobody, nobody’s love #Maroon5 #NobodysLove #M5 Music video by Maroon 5 performing Nobody's Love. © 2020 Interscope Records",

    thumbnails: {
      default: {
        url: "https://i.ytimg.com/vi/7ghhRHRP6t4/default.jpg",
        width: 120,
        height: 90,
      },
      medium: {
        url: "https://i.ytimg.com/vi/7ghhRHRP6t4/mqdefault.jpg",
        width: 320,
        height: 180,
      },
      high: {
        url: "https://i.ytimg.com/vi/7ghhRHRP6t4/hqdefault.jpg",
        width: 480,
        height: 360,
      },
      standard: {
        url: "https://i.ytimg.com/vi/7ghhRHRP6t4/sddefault.jpg",
        width: 640,
        height: 480,
      },
      maxres: {
        url: "https://i.ytimg.com/vi/7ghhRHRP6t4/maxresdefault.jpg",
        width: 1280,
        height: 720,
      },
    },

    categoryId: "10",
    liveBroadcastContent: "none",
    channelTitle: "Maroon5VEVO",
    tags: ["maroon"],
  },
  contentDetails: {
    duration: "PT3M50S",
    dimension: "2d",
    definition: "hd",
    caption: "true",
    licensedContent: true,
    regionRestriction: {
      blocked: ["BD"],
    },
    contentRating: {},
    projection: "rectangular",
  },
  statistics: {
    viewCount: "37941012",
    likeCount: "575868",
    favoriteCount: "0",
    commentCount: "18900",
  },
};

export const channelDetails: ChannelDetails = {
  kind: "youtube#channel",
  id: "UCBVjMGOIkavEAhyqpxJ73Dw",
  snippet: {
    title: "Maroon 5",
    description:
      "Welcome to the Maroon 5 official Youtube Channel. Head to our website for more info- www.maroon5.com",
    customUrl: "@maroon5",
    publishedAt: "2006-03-09T03:19:51Z",

    thumbnails: {
      default: {
        url: "https://yt3.ggpht.com/S_jTelpAHOdADumYkZAtwyLydEkqtv39s3T-Rmif0v1WCDb8pZit-Vlo43pR1jBEn0Tmcpkx=s88-c-k-c0x00ffffff-no-nd-rj",
        width: 88,
        height: 88,
      },

      medium: {
        url: "https://yt3.ggpht.com/S_jTelpAHOdADumYkZAtwyLydEkqtv39s3T-Rmif0v1WCDb8pZit-Vlo43pR1jBEn0Tmcpkx=s240-c-k-c0x00ffffff-no-nd-rj",
        width: 240,
        height: 240,
      },
      high: {
        url: "https://yt3.ggpht.com/S_jTelpAHOdADumYkZAtwyLydEkqtv39s3T-Rmif0v1WCDb8pZit-Vlo43pR1jBEn0Tmcpkx=s800-c-k-c0x00ffffff-no-nd-rj",
        width: 800,
        height: 800,
      },
    },
  },

  contentDetails: {
    relatedPlaylists: {
      likes: "",
      uploads: "UUBVjMGOIkavEAhyqpxJ73Dw",
    },
  },

  statistics: {
    viewCount: "23149869979",
    subscriberCount: "36800000",
    hiddenSubscriberCount: false,
    videoCount: "176",
  },

  brandingSettings: {
    channel: {
      title: "Maroon 5",
      description:
        "Welcome to the Maroon 5 official Youtube Channel. Head to our website for more info- www.maroon5.com",
      keywords: `"maroon 5 Adam Levine" "James Valentine" "Jesse Carmichael" "Mickey Madden" "Matt Flynn"`,
      unsubscribedTrailer: "Ntc2XNAGGMQ",
    },

    image: {
      bannerExternalUrl: `https://yt3.googleusercontent.com/JAjvs05GQkK0RwQwQFw0DQ6GmxVfb1T9Ua-rTPZ9T1n845otE3RTsaCLKdV889YPSmUY_A4OVV8`,
    },
  },
};

export const demoThumbnailUrl =
  "https://i.ytimg.com/vi/B20q2zJ8TbU/hqdefault_live.jpg";
export const demoChannelUrl = "/channel/UCmXmlB4-HJytD7wek0Uo97A";
export const demoVideoUrl = "/video/GDa8kZLNhJ4";
export const demoChannelTitle = "JavaScript Mastery";
export const demoVideoTitle =
  "Build and Deploy 5 JavaScript & React API Projects in 10 Hours - Full Course | RapidAPI";
export const demoProfilePicture =
  "http://dergipark.org.tr/assets/app/images/buddy_sample.png";
